import { supabase } from '../supabase';

export async function fetchSavedProductIds(userId) {
  const { data, error } = await supabase
    .from('saved_products')
    .select('product_id')
    .eq('user_id', userId);
  if (error) throw error;
  return new Set(data.map((row) => row.product_id));
}

export async function fetchSavedProducts(userId) {
  const { data: savedRows, error: savedError } = await supabase
    .from('saved_products')
    .select('product_id')
    .eq('user_id', userId);
  if (savedError) throw savedError;

  const ids = savedRows.map((row) => row.product_id);
  if (ids.length === 0) return [];

  const { data: products, error: productsError } = await supabase
    .from('products')
    .select('*')
    .in('id', ids);
  if (productsError) throw productsError;
  return products ?? [];
}

export async function saveProduct(userId, productId) {
  const { error } = await supabase
    .from('saved_products')
    .insert({ user_id: userId, product_id: productId });
  if (error) throw error;
}

export async function unsaveProduct(userId, productId) {
  const { error } = await supabase
    .from('saved_products')
    .delete()
    .eq('user_id', userId)
    .eq('product_id', productId);
  if (error) throw error;
}
